exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".overlay.content-centered .overlay-body[data-v-2bf2ff4c]{height:100%;align-items:center;justify-content:center;display:flex}.overlay.content-centered .container[data-v-2bf2ff4c]{align-self:center}", ""]);
